import React, { useEffect, useMemo, useState } from "react";
import { Tabs, Progress } from "antd";
import "./CoinWallet.scss";
import { ThunderboltOutlined, TrophyOutlined, StepForwardOutlined } from '@ant-design/icons';
import coinIcon from "../../assets/images/flat-icon/dollar.png";
import training from "../../assets/images/flat-icon/training.png";
import waterGlass from "../../assets/images/flat-icon/water-bottle.png";

import medication from "../../assets/images/flat-icon/meditation.png";
import gradtitude from "../../assets/images/flat-icon/gratitude.png";
import sleep from "../../assets/images/flat-icon/sleep.png";
import exercise from "../../assets/images/flat-icon/exercise.png";
import { StarOutlined, HistoryOutlined, ClockCircleOutlined } from '@ant-design/icons';
import {
  useGemificationsQuery
} from '../../utils/apiSlice';
import fire from '../../assets/images/flat-icon/fire.png';
import medicine from '../../assets/images/flat-icon/syringe.png';

const CoinWallet = ({ totalCoins }: any) => {
  const [walletData, setWalletData] = useState<any>()
  const getStoredUser = () => {
    // Try localStorage
    const localData = localStorage.getItem("userData");
    if (localData) return JSON.parse(localData);

    // Fallback to sessionStorage
    const sessionData = sessionStorage.getItem("userData");
    if (sessionData) return JSON.parse(sessionData);

    // Return default if neither exists
    return {};
  }
  const storedUser = getStoredUser();

  const userId =
    storedUser?.userId ||
    null;
  const { data: apiResponse, isLoading } = useGemificationsQuery(userId, {
    skip: !userId, // very important
  });
  const logData = [
    {
      id: 1,
      name: 'Steps',
      points: '+5',
      img: training,
      theme: '#e1f5fe' // Light Blue background for icon box
    },
    {
      id: 2,
      name: 'Water',
      points: '+5',
      img: waterGlass,
      theme: '#e3f2fd' // Soft Azure
    },
    {
      id: 3,
      name: 'Exercise',
      points: '+8',
      img: exercise,
      theme: '#f3e5f5' // Light Purple
    }
  ];

  const missionData = [
    {
      id: 1,
      title: 'Walk 10,000 steps',
      reward: '+25',
      current: 8241,
      total: 10000,
      percent: 82,
      footer: 'via Apple / Google Health',
      img: training
    },
    {
      id: 2,
      title: 'Drink 8 glasses of water',
      reward: '+15',
      current: 6,
      total: 8,
      percent: 75,
      footer: 'glasses',
      img: waterGlass
    }
  ];

  const challengesData = [
    { id: 1, title: '10-min Meditation', reward: '+30', img: medication },
    { id: 2, title: 'Gratitude Journal', reward: '+20', img: gradtitude }
  ];

  const healthMetricsData = [
    { id: 1, label: 'Steps', value: '6842', goal: '8000', img: training, active: false },
    { id: 2, label: 'Water', value: '5', goal: '8', img: waterGlass, active: false },
    { id: 3, label: 'Sleep', value: '7.2h', goal: '8h', img: sleep, active: true } // Active highlight ke liye
  ];

  // const activityData = [
  //   { id: 1, title: 'Completed 8,000 steps', time: '2h ago', points: '+25', img: training },
  //   { id: 2, title: 'Drank 8 glasses water', time: '5h ago', points: '+15', img: waterGlass },
  //   { id: 3, title: '7-day streak bonus', time: '1d ago', points: '+50', img: fire },
  //   { id: 4, title: 'Medication adherence', time: '1d ago', points: '+20', img: medicine },
  //   { id: 5, title: 'Morning meditation', time: '2d ago', points: '+10', img: medication }
  // ];


  useEffect(() => {
    // example: if data comes as props or query
    if (apiResponse?.data) {
      setWalletData(apiResponse.data);
      totalCoins(apiResponse.data)
    }
  }, [apiResponse]);

  const weeklyCoins = useMemo(() => {
    if (!walletData?.recentTransactions) return 0;

    const now = new Date();
    return walletData.recentTransactions
      .filter((t: any) => {
        const date = new Date(t.createdAt);
        return now.getTime() - date.getTime() <= 7 * 24 * 60 * 60 * 1000;
      })
      .reduce((sum: number, t: any) => sum + t.coinsChanged, 0);
  }, [walletData]);


  const activityData = useMemo(() => {
    if (!walletData?.recentTransactions) return [];

    return walletData.recentTransactions.map((item: any, index: number) => ({
      id: index,
      title: item.message,
      time: new Date(item.createdAt).toLocaleString(),
      points: `${item.coinsChanged > 0 ? "+" : ""}${item.coinsChanged}`,
      img:  ["MEDICATION_TAKEN_ON_TIME", "MEDICATION_TAKEN_LATE"].includes(item.eventType) ? medicine : fire
    }));
  }, [walletData]);


  const timeAgo = (dateStr: string): string => {
    if (!dateStr) return "";
    const now = new Date();
    const past = new Date(dateStr);
    const diffMs = now.getTime() - past.getTime();
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHr = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHr / 24);

    if (diffSec < 60) return "Just now";
    if (diffMin < 60) return `${diffMin} min ago`;
    if (diffHr < 24) return `${diffHr} hr ago`;
    if (diffDay < 7) return `${diffDay} day${diffDay > 1 ? "s" : ""} ago`;
    return past.toLocaleDateString();
  };
  return (
    <Tabs defaultActiveKey="1" className="tara-tabs">
      <Tabs.TabPane tab="Overview" key="1">
        {/* Balance Card */}
        <div className="balance-card">
          <div className="card-top">
            <span className="label">Your Tara coins</span>
            <div className="coin-display">
              <div className="coin-image-container">
                <img src={coinIcon} alt="Tara Coin" className="coin-png" />
              </div>
              <span className="amount">{walletData?.lifetimeCoinsEarned ? walletData?.lifetimeCoinsEarned : 0}</span>
            </div>
          </div>
          <div className="badge-row">
            <span className="tara-badge">
              {walletData?.currentTier ? walletData?.currentTier : ''} • Level {walletData?.currentLevel ? walletData?.currentLevel : 0}
            </span>
            <span className="tara-badge">
              ★ {walletData?.streaks?.[0]?.currentStreakDays ?? 0}-day streak
            </span>
          </div>
          <div className="card-footer">
            <span>+{weeklyCoins ? weeklyCoins : 0} this week</span>
            <span>92% med adherence</span>
          </div>
        </div>

        {/* Dark Level Tracker */}
        <div className="level-tracker">
          <div className="lvl-box">
            <small>LV.</small>
            <strong>{walletData?.currentLevel ? walletData?.currentLevel : 0}</strong>
          </div>
          <div className="lvl-progress-area">
            <div className="lvl-info">
              <span>360 coins to Level {walletData?.currentLevel ? walletData?.currentLevel : 0}</span>
            </div>
            <Progress
              percent={walletData?.lifetimeCoinsEarned ? walletData?.lifetimeCoinsEarned : 0}
              showInfo={false}
              strokeColor="#f39c12"
              trailColor="#3d4251"
              strokeWidth={6}
            />
            <div className="lvl-footer">
              <span>{walletData?.lifetimeCoinsEarned ? walletData?.lifetimeCoinsEarned : 0} / 1,600 • {walletData?.currentTier ? walletData?.currentTier : ''}</span>
            </div>
          </div>
        </div>

        {/* Quick Log Grid */}
        <div className="section-header">
          <ThunderboltOutlined className="section-icon" />
          <h5 className="section-title">QUICK REWARDS</h5>
        </div>
        <div className="quick-log-grid">
          {logData.map((item) => (
            <div className="log-card" key={item.id}>
              {/* Inline style for dynamic background if needed */}
              <div className="log-icon-box" style={{ backgroundColor: item.theme }}>
                <img src={item.img} alt={item.name} />
              </div>
              <div className="log-content">
                <span className="log-name">{item.name}</span>
                <span className="log-points">{item.points}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Daily Missions */}
        <div className="section-header">
          <div className="title-wrapper">
            <TrophyOutlined className="mission-icon me-2" />
            <h5 className="section-title">DAILY MISSIONS</h5>
          </div>
          <span className="mission-count">0 / {missionData.length} done</span>
        </div>
        <div className="mission-container-card">
          {missionData.map((mission, index) => (
            <div className="mission-row cursor-pointer" key={mission.id}>
              <div className="mission-info">
                <div className="mission-title-content">
                  <div className="icon-wrapper"><img src={mission.img} alt={mission.title} className="mission-png" /></div>
                  <span>{mission.title}</span>
                </div>
                <span className="reward-tag">{mission.reward}</span>
              </div>

              <Progress
                percent={mission.percent}
                strokeColor="#1a6d54"
                showInfo={false}
                size="small"
              />

              <div className="mission-footer-text">
                <small>{mission.current.toLocaleString()} / {mission.total.toLocaleString()}</small>
                <small className="source">{mission.footer}</small>
              </div>

              {/* Divider line except for the last item */}
              {index !== missionData.length - 1 && <div className="divider" />}
            </div>
          ))}
        </div>

        <div className="tara-coins-content">
          {/* BONUS CHALLENGES SECTION */}
          <div className="section-header">
            <div className="title-wrapper">
              <StarOutlined className="challenge-icon" />
              <h5 className="section-title">Bonus Challenges</h5>
            </div>
            <span className="limited-tag"><ClockCircleOutlined /> Limited</span>
          </div>
          <div className="bonus-challenges-card cursor-pointer">
            {challengesData.map((item) => (
              <div className="challenge-row" key={item.id}>
                <div className="challenge-info">
                  <img src={item.img} alt={item.title} className="challenge-img" />
                  <span>{item.title}</span>
                </div>
                <span className="reward-badge">{item.reward}</span>
              </div>
            ))}
          </div>

          {/* TODAY'S HEALTH METRICS SECTION */}
          <div className="section-header" style={{ marginTop: '24px' }}>
            <div className="title-wrapper">
              <HistoryOutlined className="metrics-icon" />
              <h5 className="section-title">Today's Health Metrics</h5>
            </div>
          </div>

          <div className="metrics-grid cursor-pointer">
            {healthMetricsData.map((metric) => (
              <div className={`metric-card ${metric.active ? 'active' : ''}`} key={metric.id}>
                <img src={metric.img} alt={metric.label} className="metric-img" />
                <div className="metric-value">{metric.value}</div>
                <div className="metric-label">{metric.label}</div>
                <div className="metric-goal">Goal: {metric.goal}</div>
              </div>
            ))}
          </div>

        </div>

        <div className="section-header" style={{ marginTop: '24px' }}>
          <div className="title-wrapper">
            <HistoryOutlined className="activity-icon me-2" />
            <h5 className="section-title">Recent Activity</h5>
          </div>
        </div>

        <div className="activity-container-card">
          {activityData?.length > 0 ? (
            activityData.map((activity: any) => (
              <div className="activity-row cursor-pointer" key={activity?.id}>
                <div className="activity-left">
                  <div className="activity-img-box">
                    <img src={activity?.img} alt={activity?.title} />
                  </div>
                  <div className="activity-text">
                    <span className="activity-title">
                      {activity?.title?.replace(/\s*\(\d+\s*minutes?\s*late\)/i, "").trim()}
                    </span>
                    <span className="activity-time">{timeAgo(activity?.time)}</span>
                  </div>
                </div>

                <div className="activity-right">
                  <span className="activity-points">{activity?.points}</span>
                </div>
              </div>
            ))
          ) : (

            <div className="activity-empty" style={{
              padding: '10%',
              textAlign: 'center'
            }}>
              <p>No activity found</p>
            </div>
          )}
        </div>
      </Tabs.TabPane>

      {/* <Tabs.TabPane tab="Earn" key="2" disabled />
      <Tabs.TabPane tab="Levels" key="3" disabled />
      <Tabs.TabPane tab="Rewards" key="4" disabled /> */}
    </Tabs>
  );
};

export default CoinWallet;
